import React, { Component } from "react"
import PropTypes from "prop-types"
import Lightbox from "./Lightbox"
import { CircularProgress } from "@material-ui/core"
import MarkdownWrapper from "../../MarkdownWrapper"
import { Image } from "lucide-react"

class ModalImage extends Component {
  state = {
    loading: true,
    modalOpen: false,
    error: false,
  }

  toggleModal = () => {
    if (this.state.error) return // Não abre o modal se houve erro
    this.setState((prev) => ({
      modalOpen: !prev.modalOpen,
    }))
  }

  handleOnLoad = () => {
    this.setState({ loading: false, error: false })
  }

  handleOnError = () => {
    this.setState({ loading: false, error: true })
  }

  render() {
    const {
      className,
      small,
      smallSrcSet,
      medium,
      large,
      alt,
      hideDownload,
      hideZoom,
      showRotate,
      imageBackgroundColor,
    } = this.props
    const { modalOpen, loading, error } = this.state

    return (
      <div style={{ position: "relative", display: "inline-block" }}>
        {loading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 2,
              pointerEvents: "none",
            }}
          >
            <CircularProgress />
          </div>
        )}

        {error ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Image />
            <MarkdownWrapper>*_Não foi possível recuperar o arquivo de mídia_*</MarkdownWrapper>
          </div>
        ) : (
          <img
            className={className}
            style={{
              cursor: error ? "default" : "pointer",
              maxWidth: "100%",
              maxHeight: "100%",
              display: "block",
              filter: loading ? "blur(3px)" : "none",
              transition: "filter 0.3s",
              opacity: error ? 0.5 : 1,
            }}
            onClick={this.toggleModal}
            src={small}
            srcSet={smallSrcSet}
            alt={alt}
            decoding="async"
            loading="eager"
            fetchpriority="high"
            onLoad={this.handleOnLoad}
            onError={this.handleOnError}
          />
        )}

        {modalOpen && !error && (
          <Lightbox
            medium={medium}
            large={large}
            alt={alt}
            onClose={this.toggleModal}
            hideDownload={hideDownload}
            hideZoom={hideZoom}
            showRotate={showRotate}
            imageBackgroundColor={imageBackgroundColor}
          />
        )}
      </div>
    )
  }
}

ModalImage.displayName = "ModalImage"

ModalImage.propTypes = {
  className: PropTypes.string,
  small: PropTypes.string.isRequired,
  smallSrcSet: PropTypes.string,
  medium: PropTypes.string,
  large: PropTypes.string,
  alt: PropTypes.string,
  hideDownload: PropTypes.bool,
  hideZoom: PropTypes.bool,
  showRotate: PropTypes.bool,
  imageBackgroundColor: PropTypes.string,
}

export default ModalImage
